/* @format */
import store from '@/stores';

/**
 * @param {import('vue-router').Route} to
 * @param {import('vue-router').Route} from
 * @param {function} next
 */
export const inactiveGuard = (to, from, next) => {
    if (to.name !== 'AccountInactive' && to.name !== 'AccountConnectWiseInactive') {
        // Ignore any route that are not the inactive routes
        return true;
    }

    const { isLoggedIn, user } = store.state;
    const { isActive, isConnectWise } = user.activeState;

    if (
        (isLoggedIn === false && from.name === 'AccountInactive') ||
        from.name === 'AccountConnectWiseInactive'
    ) {
        store.commit('clearUser');
    }

    if (to.name === 'AccountInactive') {
        if (!isActive && isLoggedIn === false) {
            next();
        } else {
            next('/');
        }

        return false;
    }

    if (to.name === 'AccountConnectWiseInactive') {
        if (!isActive && isConnectWise === true && isLoggedIn === false) {
            next();
        } else {
            next('/');
        }

        return false;
    }

    return true;
};
